import React from 'react';
import { motion } from 'framer-motion';
const photos = [{
  src: 'https://cdn.magicpatterns.com/uploads/aWuTopNPwAAQMv4Gw2r8b6/EL_MIRADOR_TRES_CABANAS.png',
  alt: 'Las cabañas del complejo sobre la ladera serrana',
  label: 'Las cabañas',
  className: 'col-span-1 md:col-span-2 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ncMFF7n1hRuqr2Q8QosK4b/EL_MIRADOR_NEVADO_1.jpg',
  alt: 'El complejo nevado entre los pinos',
  label: 'El Mirador nevado',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1JS4tyzoRrmaBsqEk24wuK/EL_MIRADOR_CABANA_1.jpg',
  alt: 'Galería exterior de la cabaña Tica con vista al verde',
  label: 'Galería con vista',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2UvLtFx36ajotUXQkWCfMu/EL_MIRADOR_JARDIN.jpg',
  alt: 'Jardín con hamaca paraguaya y quincho entre los pinos',
  label: 'Jardín y descanso',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oGy1vh19qn3bjQyzeUenDp/EL_MIRADOR_PARRILA_MEJOR.png',
  alt: 'Parrilla y quincho con vista al valle',
  label: 'Parrilla con vista',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/gmzC5Gf1ShbVoy7TrdXKtb/EL_MIRADOR_PILETAS.jpg',
  alt: 'Tres piscinas climatizadas rodeadas de pinos',
  label: 'Piscinas climatizadas',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/saywunRgqXv7Hy3cpDJ86M/EL_MIRADOR_ATARDECER.jpg',
  alt: 'Atardecer en el valle con un mate sobre la mesa',
  label: 'Atardeceres serranos',
  className: 'col-span-1 row-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5K8Q22VJ6HaWxAzKahMTfL/EL_MIRADOR_SALA_DE_JUEGOS.jpg',
  alt: 'Salón de juegos con metegol y pool',
  label: 'Salón de juegos',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/31doTkMp2WdyLZLLXCtiDt/EL_MIRADOR_DESAYUNO.jpg',
  alt: 'Desayunador con vista panorámica al valle',
  label: 'Desayunador con vista',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iyJie1Hjso4EBVC6tUiVX1/EL_MIRADOR_VISTA.jpg',
  alt: 'Vista al valle con la piscina y el entorno natural',
  label: 'La vista del complejo',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/hmoPh8c2TYMx5oaGaJD7V1/EL_MIRADOR_CASCADA.png',
  alt: 'Cascada entre las rocas del río',
  label: 'La cascada',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/aGSje7kvdKY5zNvnUEAi9y/EL_MIRADOR_PAISAJE_4.png',
  alt: 'El río serpenteando por el valle con el complejo en la ladera',
  label: 'El valle y el río',
  className: 'col-span-1 row-span-1'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/o65BiDsHMd21QYXN1jznqj/EL_MIRADOR_RIO_EL_DURAZNO.png',
  alt: 'El río El Durazno entre las sierras',
  label: 'Río El Durazno',
  className: 'col-span-1 row-span-1'
}];
export function Gallery() {
  return <section id="galeria" className="py-24 bg-sand-light" data-id="element-163">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-164">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-165">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl text-olive-dark mb-6" data-id="element-166">
            Conocé Cabañas El Mirador
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-charcoal-light" data-id="element-167">
            Te invitamos a descubrir cada rincón del complejo: las cabañas, los
            espacios exteriores, la piscina, el entorno natural y las vistas que
            hacen de este lugar una experiencia especial.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 auto-rows-[250px]" data-id="element-168">
          {photos.map((photo, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`relative rounded-2xl overflow-hidden group ${photo.className}`} data-id="element-169">
              <img src={photo.src} alt={photo.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-170" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-171"></div>
              <span className="absolute bottom-4 left-4 text-white font-medium text-sm tracking-wide opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300" data-id="element-172">
                {photo.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}